import React from 'react';
import { Button, Stack } from '@mui/material';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';

import { FDataGrid, FGrid, FGridMoneyCell } from '../grid';
import { IAllocationLink } from './budgetallocation.models';

type Props = {
  rows: IAllocationLink[];
  selection: GridRowSelectionModel;
  loading?: boolean;
  mutationDisabled?: boolean;
  onSelectionChange: (selection: GridRowSelectionModel) => void;
  onUnmapSelected: () => void;
};

const selectionCount = (selection: GridRowSelectionModel | any): number => {
  if (!selection) return 0;

  // MUI X v8: { type: 'include' | 'exclude', ids: Set<GridRowId> }
  if (selection.ids && typeof selection.ids[Symbol.iterator] === 'function') {
    return Array.from(selection.ids as Iterable<any>).length;
  }

  // Compatibility with older/custom FDataGrid models.
  if (Array.isArray(selection)) return selection.length;

  return 0;
};
class BudgetAllocationLinksGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'activity_code', headerName: 'Activity', width: 140 },
    { field: 'activity_name', headerName: 'Activity Name', flex: 1, minWidth: 280 },
    { field: 'lineitem_code', headerName: 'Line Item', width: 140 },
    { field: 'lineitem_name', headerName: 'Line Item Name', flex: 1, minWidth: 280 },
    {
      field: 'allocationratio',
      headerName: 'Ratio',
      width: 110,
      renderCell: (params: any) =>
        `${(Number(params.value || 0) * 100).toLocaleString('fr-FR', {
          maximumFractionDigits: 2,
        })}%`,
    },
    { field: 'allocatedamount', headerName: 'Amount', width: 150, renderCell: FGridMoneyCell },
  ];

  render() {
    const selectedCount = this.props.selection?.ids?.size ?? 0;
    const canUnmap =
      !this.props.loading &&
      !this.props.mutationDisabled &&
      selectedCount > 0;

    // console.log('muationdisabled', this.props.mutationDisabled);
    // console.log('selectedCount', selectedCount);

    // console.log('selections',this.props.selection)

    return (
      <Stack spacing={1}>
        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteSweepIcon />}
            disabled={!canUnmap}
            onClick={this.props.onUnmapSelected}
          >
            Unmap Selected
          </Button>
        </Stack>

        {/* <FGrid
          title="Cost Center Activity Budget Mappings"
          subtitle="Existing financialisation links for the selected Cost Centre. Select links here to unmap them."
          rows={this.props.rows || []}
          columns={this.columns}
          loading={this.props.loading}
          height={420}
          showQuickFilter
          toolbarSx={{ backgroundColor: '#f6efe8' }}
          getRowId={(row: any) => row.recid || row.id}
          checkboxSelection
          rowSelectionModel={this.props.selection}
          onRowSelectionModelChange={(selection: GridRowSelectionModel) =>
            this.props.onSelectionChange(selection)
          }
          pageSizeOptions={[10, 25, 50]}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
        /> */}

        <FDataGrid
          title="Cost Center Activity Budget Mappings"
          subtitle="Existing financialisation links for the selected Cost Centre. Select links here to unmap them."
          rows={this.props.rows || []}
          columns={this.columns}
          loading={this.props.loading}
          height={420}
          showQuickFilter
          toolbarSx={{ backgroundColor: '#f6efe8' }}
          getRowId={(row: any) => row.recid || row.id}
          checkboxSelection
          rowSelectionModel={this.props.selection}
          onRowSelectionModelChange={this.props.onSelectionChange}
          pageSizeOptions={[10, 25, 50]}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
        />
      </Stack>
    );
  }
}

export default BudgetAllocationLinksGrid;
